// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__SMD0G","total":"Cart_total__U6L3z","actions":"Cart_actions__so2s2","button--alt":"Cart_button--alt__riJ5b","button":"Cart_button__U4KZR"};